import React from 'react';
// import $ from 'jquery';
import OwlCarousel from "react-owl-carousel-rtl";
import '../../../node_modules/owl.carousel/dist/assets/owl.carousel.css'
import '../../../node_modules/owl.carousel/dist/assets/owl.theme.default.css';
// import 'owl.carousel/dist/owl.carousel.js'
import CommentSliderItemSlider from './commentSliderItemSlider';

const CoustomerComments = ({ customerCm }) => {
    // console.log(customerCm);

    const coustomer = customerCm.map((cm) => {
        return <CommentSliderItemSlider key={cm.id}

            data={
                {
                    summary: cm.summary,
                    name: cm.name,
                    subtitle: cm.subtitle,
                    imagecustomer: cm.imagecustomer
                }
            }

        />
    })
    // console.log(coustomer);

    const options = {
        loop: true,
        // rtl:true,
        margin: 20,
        autoplay: true,
        dots: false,
        autoplayTimeout: 8500,
        smartSpeed: 450,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            1000: {
                items: 2
            }
        }
    };

    return (
        <div className="coustomer-comments">

            <div className="block-title">
                <h6 className="title">نظرات مشتریان</h6>
            </div>

            <OwlCarousel className='owl-carousel owl-theme'  {...options} rtlClass="owl-rtl" rtl={true} >
                {coustomer}
            </OwlCarousel>

        </div>
    )
}
export default CoustomerComments;